import React from "react";
import Image from "../../components/images/Image";

export default ({ large_image }) => {
  return (
    <div className="oHomeImage">
      <Image image={large_image} />
    </div>
  );
};
